import {
  PoleGroupCapacity,
  PoleLimitData,
} from '../../../../../../api/theHive/noticeCoverage/types';
import { GroupLimit, PoleLimit, PoleStatus } from './types';

export const mapPole = (pole: PoleLimitData): PoleLimit => ({
  id: pole.id,
  name: pole.name ?? '—',
  state: pole.uf,
});

export const mapGroup = (group: PoleGroupCapacity): GroupLimit => ({
  criteriaGroupId: group.criteria_group_id,
  criteriaGroupName: group.criteria_group_name,
  activeAccreditations: group.active_accreditations,
  limit: group.max_companies,
  availableSlots: group.available_slots,
  waitlistCount: group.waitlist_count,
});

export const buildDraftLimits = (
  groups: GroupLimit[]
): Record<number, string> =>
  Object.fromEntries(
    groups.map((group) => [group.criteriaGroupId, String(group.limit)])
  );

/** Occupancy in %, guarded against a zero limit (avoids NaN/Infinity). */
export const occupancyPct = (active: number, limit: number): number => {
  if (limit <= 0) return active > 0 ? 100 : 0;
  return (active / limit) * 100;
};

export const getStatus = (
  activeAccreditations: number,
  limit: number
): PoleStatus => {
  if (activeAccreditations >= limit) {
    return { color: 'error', label: 'Limite atingido' };
  }
  if (occupancyPct(activeAccreditations, limit) >= 90) {
    return { color: 'warning', label: 'Próximo do limite' };
  }
  return { color: 'success', label: 'Disponível' };
};
